'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Cookies from 'js-cookie';
import { Button } from '../Button';
import styles from './styles.module.scss';
import { useCookiesConsent } from '../../providers';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { setCookiesConsented } = useCookiesConsent();

  const handleAccept = () => {
    setIsVisible(false);
    Cookies.set('cookie_consent', 'true', { expires: 365 });
    setCookiesConsented(true);
  };

  const handleReject = () => {
    setIsVisible(false);
    Cookies.set('cookie_consent', 'false', { expires: 365 });
  };

  useEffect(() => {
    const cookiesAccepted = Cookies.get('cookie_consent');
    if (cookiesAccepted === undefined) {
      setIsVisible(true);
    } else {
      if (cookiesAccepted === 'true') {
        setCookiesConsented(true);
      }
    }
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <p className={styles.description}>
        This website uses cookies to ensure you get the best experience.
        {' '}
        <Link href="/cookie-policy">
          Cookie Policy
        </Link>
      </p>
      <div className={styles.buttonsContainer}>
        <Button
          onClick={handleReject}
          title="Reject"
          type='tertiary'
        >
          Reject
        </Button>
        <Button
          onClick={handleAccept}
          title="Accept"
        >
          Accept
        </Button>
      </div>
    </div>
  );
};
